import React, { Fragment } from "react";
import Markdown from "react-markdown";
import { Link } from "react-router";
import { formatRelative } from "date-fns";

function Notifications({
  data = [],
  type = "messages",
  setDisplayModal = false,
}: {
  data: any[];
  type: string;
  setDisplayModal?: any;
}) {
  if (!data) {
    return null;
  }

  return (
    <>
      {data.length === 0 ? (
        <div className="rounded-xl bg-surface-base w-full p-3 text-center">
          You have no {type === "messages" ? "messages" : "notifications"}
        </div>
      ) : (
        ""
      )}
      <div className="flex flex-col gap-3">
        {data.map((notification) => (
          <Fragment key={notification.id}>
            <Link
              to={`${
                type === "messages"
                  ? `/inbox#exchange=${
                      notification.metadata.exchangeTitleSafe
                    }&gifteeId=${notification.metadata.gifteeId}&originType=${
                      notification.metadata.originType === "giftee"
                        ? `${
                            notification.metadata.originType.includes("rematch")
                              ? `rematch-`
                              : ""
                          }gifter`
                        : `${
                            notification.metadata.originType.includes("rematch")
                              ? `rematch-`
                              : ""
                          }giftee`
                    }`
                  : `${notification.url.replace("https://givin.gifts", "")}`
              }`}
              onClick={() => {
                if (setDisplayModal) {
                  setDisplayModal(false);
                }
              }}
            >
              <div
                className={`${
                  notification.isRead === 1
                    ? "bg-surface-base hover:bg-surface-lowered text-text-base"
                    : "bg-surface-lowered hover:bg-surface-base text-text-base"
                } rounded-xl p-3 hover:shadow-sm`}
              >
                <div className="flex items-center gap-3">
                  <div className="shrink-0 w-[6rem]">
                    <img
                      src={`https://images.givin.gifts/preset:sharp/resize:fit:480:0:0/format:webp/gravity:sm/plain/https://storage.ethereal.sh/gifts-public/${notification.picture}`}
                      alt=""
                      className="w-[6rem] rounded-xl"
                    />
                  </div>
                  <div className="w-full flex flex-col max-w-[calc(100%-7.5rem)] text-start">
                    <div
                      className={`${
                        notification.isRead === 1 ? "" : "font-bold gap-1"
                      } text-xs flex flex-row`}
                    >
                      <span>{notification.isRead === 1 ? "" : "•"}</span>
                      <span
                        suppressHydrationWarning={true}
                        className="bg-surface-raised text-text-base py-1 px-2 rounded-full"
                      >
                        {formatRelative(
                          new Date(notification.createdAt),
                          new Date()
                        )}
                      </span>
                    </div>
                    <div className="font-bold text-text-primary">
                      {notification.title}
                    </div>
                    {type === "messages" ? (
                      <div className="text-xs font-bold">
                        From {notification.metadata.originType}
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="text-sm line-clamp-3 break-words overflow-hidden">
                      {type === "messages" ? (
                        <Markdown>{notification.metadata.message}</Markdown>
                      ) : (
                        notification.content
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </Fragment>
        ))}
      </div>
    </>
  );
}

export default Notifications;
